function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}
function extractWidgetId(url) {
  if (typeof url !== 'string') return null;
  const match = url.match(/\/files\/([^_]+?-\d+)(?:_|\.|\?|$)/);
  return match ? match[1] : null;
}

let vwGeneration = 0;

const handleSrcChange = debounce((img) => {
  // A quick second swatch change can let this cycle's own delayed re-trigger below fire after a
  // newer cycle has already started (the setTimeout below isn't cancelled by a later click, only
  // the debounce wrapper is) - tag this run so the stale trigger can detect it's been superseded
  // and skip itself, instead of rebuilding an outdated widget right before the newer one replaces it.
  const myGeneration = ++vwGeneration;

  const containers = document.querySelectorAll('.vw-parent');
  if (containers.length > 0) {
    containers.forEach(container => container.classList.remove('vw-parent'));

  }

  const widgets = document.querySelectorAll('.vw-product-widget');
  if (widgets.length > 0) {
    widgets.forEach(widget => widget.remove());
  }

  const btns = document.querySelectorAll('#cloneVwBtn');
  if (btns.length > 0) btns.forEach(btn => btn.remove());

  // The repair clone below is only ever needed transiently (eg. while VideoWise's own widget is
  // briefly disrupting the sibling structure around .thumb) - clean up any previous one here so it
  // never persists as a permanent leftover element after switching to a product that doesn't need it.
  const repairClones = document.querySelectorAll('.js-vw-thumb-repair-clone');
  if (repairClones.length > 0) repairClones.forEach(clone => clone.remove());

  const thumbVw = document.querySelector('.thumb');
  const imgvw = thumbVw?.querySelector('img');

  if (thumbVw && imgvw) {
    const prevImg = thumbVw.previousElementSibling;
    imgvw.alt = '';
    // Guard against inserting more than one repair clone - without this, separate (non-debounced)
    // runs of this function could each add another leftover <img> that's never cleaned up.
    if ((!prevImg || prevImg.tagName !== 'IMG') && !thumbVw.parentNode.querySelector('.js-vw-thumb-repair-clone')) {
      const imgClone = imgvw.cloneNode(true);
      imgClone.classList.add('js-vw-thumb-repair-clone');
      thumbVw.parentNode.insertBefore(imgClone, thumbVw);
    }
  }

   const swatch = document.querySelector('.js-swatch_wrapper.current');
    if (swatch) {
      const images = swatch.dataset.imagesThumb?.split(';') || [];
      let hasReeviewMatch = false;

      document.querySelectorAll('.js-desktop-images-wrapper img:not(.zoomImg)').forEach((imgEl, index) => {
        const imageSrc = images[index];
        if (imageSrc && imageSrc.includes('reeview')) {
            hasReeviewMatch = true;
            const widgetId = extractWidgetId(imageSrc);
            if (widgetId) {
              // The flat position that matched can be the visible sibling image rather than the
              // hidden .thumb (since .thumb occupies a position in the same count) - if so, tag
              // .thumb's own image instead, since that's the hidden element VideoWise's widget is
              // injected into.
              let targetEl = imgEl;
              if (!imgEl.closest('.thumb')) {
                const zoomContainer = imgEl.closest('.js-zoom-container');
                const thumbImg = zoomContainer ? zoomContainer.querySelector('.thumb img') : null;
                if (thumbImg) {
                  targetEl = thumbImg;
                }
              }
              targetEl.alt = widgetId || '';
              const lastSegment = widgetId.split('-').pop();
              if (typeof window.__st !== 'undefined' && typeof window.__st.rid !== 'undefined') {
                window.__st.rid = lastSegment;
              }
            }
        }
      });

      // The swatch just selected has no video of its own - clear any widget ID left over from a
      // previously-viewed video product, otherwise VideoWise's SDK (triggered below regardless)
      // can still find that stale ID and inject the old video onto a product that shouldn't have one.
      if (!hasReeviewMatch && typeof window.__st !== 'undefined' && typeof window.__st.rid !== 'undefined') {
        window.__st.rid = '';
      }

      // Mobile: VideoWise consumes the marker <img> itself when it builds its widget there (unlike
      // desktop's .thumb, whose own <img> is left untouched, which is why the repair-clone above only
      // needs to run for desktop). Once the widget is torn down above, nothing is left in that slide
      // for VideoWise to find and rebuild from on the next trigger - restore a plain marker image
      // before re-triggering, mirroring the same idea as the desktop repair above. Only ever targets
      // the real slide (not a swiper loop-duplicate clone) - data-swiper-slide-index is unique to the
      // real slide the marker belongs to, and this product's marker position has never shown up among
      // Swiper's own loop-duplicate clones.
      var mobileMarkerIndex = images.findIndex(function(src) { return src && src.includes('reeview'); });
      if (mobileMarkerIndex !== -1) {
        var mobileSlide = document.querySelector(
          '#gallery-swiper .swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="' + mobileMarkerIndex + '"]'
        );
        var mobileContainer = mobileSlide ? mobileSlide.querySelector('.swiper-zoom-container') : null;
        if (mobileContainer && !mobileContainer.querySelector('img') && !mobileContainer.querySelector('.vw-product-widget')) {
          var mobileImg = document.createElement('img');
          mobileImg.src = images[mobileMarkerIndex];
          mobileImg.alt = '';
          mobileContainer.appendChild(mobileImg);
        }
      }
    }

  if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
    try {
      setTimeout(() => {
        if (myGeneration !== vwGeneration) return;
        videowiseBulkTrigger();
        initVideowise();
      }, 120);
    } catch (err) {
      console.error('❌ Error calling Videowise functions:', err);
    }
  }
}, 180);

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.js-swatch_wrapper');
  if (!swatch) return;
  const img = document.querySelector('.js-desktop-image-item');
  if (!img) {
    return;
  }

  setTimeout(() => {
    handleSrcChange(img);
  }, 120);
});

// Initialize Videowise on page load for the currently selected swatch
function initializeVideowiseOnLoad() {
  let retryCount = 0;
  const maxRetries = 15; // Maximum 3 seconds of retries (15 * 200ms)
  
  // Wait for DOM to be ready and check if Videowise functions are available
  const checkAndInit = () => {
    const currentSwatch = document.querySelector('.js-swatch_wrapper.current');
    const img = document.querySelector('.js-desktop-image-item');
    
    if (currentSwatch && img) {
      // Check if Videowise functions are available, if not wait a bit more
      if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
        // On load (unlike a swatch click) there is no stale widget from a previous product to
        // clear - if VideoWise has already finished injecting its widget by the time we get here,
        // tearing it down and re-triggering only recreates a visible gap for no reason.
        var existingVideo = document.querySelector('.vw-parent video[src]');
        if (!existingVideo) {
          handleSrcChange(img);
        }
      } else if (retryCount < maxRetries) {
        // Retry after a short delay if functions aren't loaded yet
        retryCount++;
        setTimeout(checkAndInit, 120);
      }
    } else if (retryCount < maxRetries) {
      // Elements not ready yet, retry
      retryCount++;
      setTimeout(checkAndInit, 120);
    }
  };

  // Try multiple times to ensure everything is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(checkAndInit, 280);
    });
  } else {
    // DOM is already ready
    setTimeout(checkAndInit, 280);
  }

  // Also try on window load as a fallback (reset retry count)
  window.addEventListener('load', () => {
    retryCount = 0;
    setTimeout(checkAndInit, 150);
  });
}

// Start initialization
initializeVideowiseOnLoad();

